import React from "react";
import useThemeSwitcher from "./useThemeSwitcher.jsx";

export const ToggleView = () => {
  const ThemeSwitcher = useThemeSwitcher();
  return <p className="mb-0 text-white">{ThemeSwitcher}</p>;
};
